'use client';

import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

const ExtendHowItWorks = (): JSX.Element => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid className="pt-20">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyV3
            Element="h6"
            variant="unset"
            className="mb-14 text-center text-[26px] leading-[31px] md:text-[40px] md:leading-[48px]"
          >
            {t('extend_section_header8')}
          </TypographyV3>
          <TypographyV3 className="text-center">
            {t('extend_section_header9')}
          </TypographyV3>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main', md: 'main', lg: 12, xl: 11 }}
          colStart={{ sm: 'main' }}
          className="pt-20"
        >
          <div className="text-center lg:flex lg:gap-5 lg:text-left">
            <div className="md:flex-1">
              <TypographyV3
                variant="unset"
                className="pb-3.5 text-[22px] font-normal leading-[26px] md:text-[28px] md:leading-[33px]"
              >
                {t('extend_section_header_10')}
              </TypographyV3>
              <TypographyV3>{t('extend_section_header_11')}</TypographyV3>
              <ButtonV3
                variant="unset"
                size="medium"
                className="mt-8 w-60 bg-white"
                href="https://customers.extend.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('extend_section_header_12')}
              </ButtonV3>
              <div className="mt-4 flex items-center justify-center lg:justify-start">
                <TypographyV3 className="text-sm">
                  {t('powered_by')}
                </TypographyV3>
                <Image
                  className="ml-2 h-3.5"
                  src="extend/extend-trademark"
                  format="png"
                  height={16}
                  localizedAlt="extend_trademark_alt"
                  width={64}
                />
              </div>
            </div>
          </div>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main', md: 'main', lg: 13, xl: 14 }}
          className="md:pt-20"
        >
          <div className="md:flex md:justify-center xl:justify-normal">
            <div className="-ml-8 mt-14 md:m-0">
              <ArtDirectionImage
                alt="extend_how_it_works"
                width={568}
                height={400}
                format="png"
                localizedAlt="extend_app_screen_alt"
                sizes="(max-width: 767px) 390px, 566px"
                srcSet={[
                  {
                    media: '(max-width: 767px)',
                    src: 'extend/extend-device-message-mobile',
                  },
                  {
                    media: '(min-width: 768px)',
                    src: 'extend/extend-message',
                  },
                ]}
              />
            </div>
            <div className="m-auto max-w-sm md:hidden">
              <Image
                src="extend/extend-message-mobile"
                format="png"
                localizedAlt="extend_messaging_alt"
                width={568}
                height={400}
              />
            </div>
          </div>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="pt-20"
        >
          <div className="border-b border-gray-400" />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ExtendHowItWorks;
